/* External dependencies */
import { ofType, StateObservable } from 'redux-observable';
import { from, Observable } from 'rxjs';
import { catchError, switchMap, withLatestFrom } from 'rxjs/operators';

/* Local dependencies */
import { registerUser } from '../../../../../clients/custom-auth';
import { COGNITO_USER_POOL_DATA } from '../../../../../clients/cognito';
import { RootState } from '../../../../../redux/store';
import { RegisterAction, RegisterActionTypes, registerFailed, RegisterRequest, registerSuccess } from './actions';

export function registerEpic(action$: Observable<RegisterAction>, state$: StateObservable<RootState>) {
  return action$.pipe(
    ofType(RegisterActionTypes.REGISTER_REQUEST),
    withLatestFrom(state$),
    switchMap(([action]: [RegisterRequest, RootState]) => {
      return from(registerUser({ ...action, userPool: COGNITO_USER_POOL_DATA })).pipe(
        switchMap(() => from([registerSuccess(action.email)])),
        catchError((error) => from([registerFailed(error)])),
      );
    }),
  );
}
